import type { VariantProps } from 'class-variance-authority';

import { cva } from 'class-variance-authority';

export { default as FilterButton } from './Button.vue';

export interface FilterButtonProps {
	isActive?: boolean;
	numberOfAppliedFilters?: number;
	showNumberOfAppliedFilters?: boolean;
	label?: string;
	variant?: FilterButtonVariant;
}

export const filterButtonVariants = cva(
	'size-min max-h-11 gap-1 px-3 py-[15px] font-sans text-sm font-normal md:max-h-[50px]',
	{
		variants: {
			variant: {
				primary:
					'flex-row border border-white-dark-3 bg-white text-primary hover:bg-white-dark-1 data-[is-active=true]:border-primary-light-2 data-[is-applied=true]:border-primary-light-1 data-[is-active=true]:bg-primary-light-2 data-[is-applied=true]:bg-primary-light-3',
				'primary-reverse':
					'flex-row-reverse border border-white-dark-3 bg-white text-primary hover:bg-white-dark-1 data-[is-active=true]:border-primary-light-2 data-[is-applied=true]:border-primary-light-1 data-[is-active=true]:bg-primary-light-2 data-[is-applied=true]:bg-primary-light-3',
				dark: 'flex-row border border-primary-light-3 bg-primary-light-4 text-white hover:bg-primary-light-2 data-[is-active=true]:border-primary-light-2 data-[is-active=true]:bg-primary-light-2 data-[is-active=true]:hover:!bg-[#2596be] data-[is-applied=true]:border-primary-light-1 data-[is-applied=true]:bg-primary-light-3 data-[is-applied=true]:hover:bg-primary-light-2',
				'dark-reverse':
					'flex-row-reverse border border-primary-light-3 bg-primary-light-4 text-white hover:bg-primary-light-2 data-[is-active=true]:border-primary-light-2 data-[is-active=true]:bg-primary-light-2 data-[is-active=true]:hover:!bg-[#2596be] data-[is-applied=true]:border-primary-light-1 data-[is-applied=true]:bg-primary-light-3 data-[is-applied=true]:hover:bg-primary-light-2',
				// Aliases for backwards compatibility (Bar.legacy.vue, Bar.enhanced.vue)
				default:
					'flex-row border border-white-dark-3 bg-white text-primary hover:bg-white-dark-1 data-[is-active=true]:border-primary-light-2 data-[is-applied=true]:border-primary-light-1 data-[is-active=true]:bg-primary-light-2 data-[is-applied=true]:bg-primary-light-3',
				reverse:
					'flex-row-reverse border border-white-dark-3 bg-white text-primary hover:bg-white-dark-1 data-[is-active=true]:border-primary-light-2 data-[is-applied=true]:border-primary-light-1 data-[is-active=true]:bg-primary-light-2 data-[is-applied=true]:bg-primary-light-3'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export type FilterButtonVariant = VariantProps<
	typeof filterButtonVariants
>['variant'];
